import React from "react";
import cn from "classnames";
import styles from "./SniperBotOffer.module.css";

interface SniperBotOfferProps {
    imageName: string; // e.g. "whale" (no extension)
    className?: string;
    title?: string;
    description?: string;
}

const SniperBotOffer: React.FC<SniperBotOfferProps> = ({
    imageName,
    className,
    title = "Sniper bot",
    description = "Launch a sniperbot to get even more profit from your operations, don't keep an eye on the whales, lead them",
}) => (
    <div
        className={cn(
            "card rounded-4xl overflow-hidden w-full h-full p-6 gap-4 justify-end flex flex-col",
            styles["sniper-bot-offer-bg-zoom"],
            className,
        )}
        style={{
            ["--offer-bg-image" as any]: `image-set(url('/images/home/offers/${imageName}.png') 1x, url('/images/home/offers/${imageName}2x.png') 2x)`,
        }}
    >
        <h3 className="text-2xl">{title}</h3>
        <p className="text-sm text-muted-foreground">{description}</p>
    </div>
);

export default SniperBotOffer;
